import { createPresentationRequest } from '@/features/promo';
import { Env } from '@/shared/config/environment';

const state = {};
const mutations = {};

const actions = {
  async createPresentationRequest({ dispatch }, { name, telephone, email }) {
    try {
      return await createPresentationRequest({ name, telephone, email });
    } catch (error) {
      const errorMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || 'Не вдалося створити запит на презентацію';

      if (Env.features.showNetworkErrorMessages) {
        dispatch('notificationModule/showNotificationErrorMessage', {
          error: error,
          title: 'Не вдалося створити запит на презентацію',
          message: errorMessage,
        }, { root: true });
      }
    }
  }
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
